// Sidebar directory tree. Mirrors the routes in App.jsx.
// A node with `children` is a folder, otherwise a file. Every folder needs a `to`:
// clicking it opens that page, and a folder is only expanded while the current
// route is inside it. A file without `to` renders as a disabled placeholder.
// Folder `id`s must be unique.
export const siteTree = {
    id: "root",
    name: "~",
    to: "/",
    children: [
        {
            id: "apps",
            name: "/apps",
            to: "/apps",
            children: [
                {
                    id: "apps/cogio",
                    name: "/cogio",
                    to: "/apps/cogio",
                    children: [
                        {name: "support", to: "/apps/cogio/support"},
                        {name: "privacy-policy", to: "/apps/cogio/privacy-policy"},
                        {name: "license", to: "/apps/cogio/license"},
                    ],
                },
                {
                    id: "apps/fundatio",
                    name: "/fundatio",
                    to: "/apps/fundatio",
                    children: [
                        {name: "support", to: "/apps/fundatio/support"},
                        {name: "privacy-policy", to: "/apps/fundatio/privacy-policy"},
                        {name: "license", to: "/apps/fundatio/license"},
                    ],
                },
            ],
        },
        {
            id: "blog",
            name: "/blog",
            to: "/blog",
            children: [
                {name: "my-agentic-coding-setup", to: "/blog/my-agentic-coding-setup"},
                {
                    name: "react-django-to-static",
                    to: "/blog/how-i-converted-my-react-django-setup-into-a-static-github-pages-site",
                },
                {name: "get-to-the-point", to: "/blog/get-to-the-point"},
                {name: "google-foobar-challenge", to: "/blog/google-foobar-challenge"},
                {name: "mathematical-artificial-intelligence", to: "/blog/mathematical-artificial-intelligence"},
            ],
        },
        {
            id: "reviews",
            name: "/reviews",
            to: "/reviews",
            children: [
                {name: "game", to: "/reviews/game"},
                {name: "toilet", to: "/reviews/toilet"},
                {name: "book", to: "/reviews/book"},
                {name: "album", to: "/reviews/album"},
                {name: "city (WIP)"},
            ],
        },
        {name: "art", to: "/art"},
        {name: "designs", to: "/designs"},
        {name: "games", to: "/games"},
        {name: "life", to: "/life"},
    ],
};

export const normalizePath = (path) => (path.length > 1 ? path.replace(/\/+$/, "") : path);
